import { render, staticRenderFns } from "./AdminShopProductList.vue?vue&type=template&id=5ce2ea10&scoped=true&"
import script from "./AdminShopProductList.vue?vue&type=script&lang=js&"
export * from "./AdminShopProductList.vue?vue&type=script&lang=js&"
import style0 from "./AdminShopProductList.vue?vue&type=style&index=0&id=5ce2ea10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce2ea10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ce2ea10')) {
      api.createRecord('5ce2ea10', component.options)
    } else {
      api.reload('5ce2ea10', component.options)
    }
    module.hot.accept("./AdminShopProductList.vue?vue&type=template&id=5ce2ea10&scoped=true&", function () {
      api.rerender('5ce2ea10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminShopProductList.vue"
export default component.exports